exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-row[data-v-2afd07fc] {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin-top: 15px;\n}\n", ""]);

// exports
